import { useMutation } from "@apollo/client";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";

import QUERY from "../../utils/service/query";

const CreateAdminForm = () => {
	const [createAdmin, { loading }] = useMutation(QUERY.ACCOUNT.CREATE_ADMIN);

	const [firstName, setFirstName] = useState("");
	const [lastName, setlastName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [cPassword, setCPassword] = useState("");

	return (
		<Form
			onSubmit={(e) => {
				e.preventDefault();
				createAdmin({
					variables: {
						email: email,
						firstName: firstName,
						lastName: lastName,
						password: password,
					},
					refetchQueries: [
						{ query: QUERY.USERS.GET_USERS, variables: { page: 1, limit: 20 } },
					],
				})
					.then(({ data }) => {
						if (data?.createAdmin === "User Already Exists") {
							toast.error("User Already Exists");
						} else {
							setFirstName("");
							setlastName("");
							setEmail("");
							setPassword("");
							setCPassword("");
							data?.createAdmin && toast.success("Created Admin Successfully");
						}
					})
					.catch((error) => {
						toast.error(error?.message || "Something went wrong!");
					});
			}}>
			<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
				<Form.Label>First Name</Form.Label>
				<Form.Control
					type="text"
					required
					placeholder="First Name"
					className="form-control-md"
					value={firstName}
					onChange={(e) => setFirstName(e.target.value)}
				/>
			</Form.Group>
			<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
				<Form.Label>Last Name</Form.Label>
				<Form.Control
					type="text"
					required
					placeholder="Last Name"
					className="form-control-md"
					value={lastName}
					onChange={(e) => setlastName(e.target.value)}
				/>
			</Form.Group>
			<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
				<Form.Label>Email address</Form.Label>
				<Form.Control
					type="email"
					required
					placeholder="name@example.com"
					className="form-control-md"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
			</Form.Group>
			<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
				<Form.Label>Password</Form.Label>
				<Form.Control
					type="password"
					required
					placeholder="Minimum 8 characters"
					className="form-control-md"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
				/>
			</Form.Group>
			<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
				<Form.Label>Confirm Password</Form.Label>
				<Form.Control
					type="password"
					required
					placeholder="Re-enter password"
					className="form-control-md"
					value={cPassword}
					onChange={(e) => setCPassword(e.target.value)}
				/>
			</Form.Group>
			{loading ? (
				<Button variant="primary" type="submit" disabled={true}>
					{"Submitting"}
				</Button>
			) : (
				<Button
					variant="primary"
					type="submit"
					disabled={
						!firstName ||
						!lastName ||
						!email ||
						!password ||
						!cPassword ||
						password !== cPassword
					}>
					{"Submit"}
				</Button>
			)}
		</Form>
	);
};

export default CreateAdminForm;
